import { Component, OnInit, HostListener } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import PerfectScrollbar from "perfect-scrollbar";
import { GuiGuard } from "../shared/guard/base-gui-guard";
import { BaseRouteGuard } from "../shared/guard/base-route-guard";
import { UserService } from "../services/user.service";
import { POService } from "../services/po.service";

import { GlobalNumberNotificationsService } from "../services/globalnumbernotifications.service";
import { GlobalNumberNotificationsOffersService } from "../services/globalnumbernotificationsoffers.service";
import { webSocket, WebSocketSubject } from "rxjs/webSocket";

declare const $: any;

//Metadata
export interface RouteInfo {
  path: string;
  title: string;
  type: string;
  icontype: string;
  collapse?: string;
  children?: ChildrenItems[];
}

export interface ChildrenItems {
  id: number;
  path: string;
  title: string;
  ab: string;
  type?: string;
}

export const MASTERROUTES: RouteInfo[] = [
  {
    path: "/master/home",
    title: "Home",
    type: "link",
    icontype: "home",
  },
  {
    path: "/master/companies",
    title: "Master Companies",
    type: "link",
    icontype: "group",
  },
  {
    path: "/master/logs",
    title: "Access Logs",
    type: "link",
    icontype: "developer_mode",
  },
];

// Menu Items
export let ROUTES: RouteInfo[];

@Component({
  selector: "app-sidebar-cmp",
  templateUrl: "sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
  providers: [UserService, GuiGuard, BaseRouteGuard],
})
export class SidebarComponent implements OnInit {
  public menuItems: any[];
  public privilegio;
  public gobig;
  public identity;
  public logoCompany = "/assets/img/greentek_solutions_logo.svg";
  public avatarImg = "../assets/img/faces/avatar.png";
  public url_redirect = "";
  ps: any;
  public vendorStatus;
  public statusInventoryClient = false;
  public statusBugReporting = false;
  public permissionStatus = false;
  public bugstatus = false;

  public notificationsOffers = 0;
  public numberNotificationsOffers: number = 0;
  myWebSocket: WebSocketSubject<any> = webSocket(
    "wss://www.greenteksolutions.com/myws",
  );

  public token;
  public favorites: any[] = [];

  public favoriteItems: any[] = [];

  public isMobile: boolean = window.innerWidth <= 991;

  @HostListener('window:resize')
  onWindowResize() {
    this.isMobile = window.innerWidth <= 991;
  }

  public unedaItems = [
    { id: 1, path: "/pages/uploaduneda", title: "Configuration", ab: "C" },
    {
      id: 2,
      path: "/tables/listunedainventory",
      title: "My Inventory",
      ab: "MI",
    },
  ];

  public ecommerceItems = [
    { id: 3, path: "/gobig/ebayaccounts", title: "Ebay Accounts", ab: "EA" },
    { id: 4, path: "/gobig/ebayexporter", title: "Ebay Sync", ab: "ES" },
    { id: 5, path: "/tables/listebayitems", title: "Synced Items", ab: "SI" },
    { id: 6, path: "/gobig/ebaylistings", title: "Ebay Listings", ab: "EL" },
    { id: 7, path: "/gobig/ebaylocations", title: "Ebay Locations", ab: "EL" },
    { id: 8, path: "/gobig/ebayorders", title: "Ebay Orders", ab: "EO" },
    { id: 9, path: "/gobig/easytemplates", title: "Easy Templates", ab: "ET" },
    { id: 10, path: "/gobig/returnpolicies", title: "Return Policy", ab: "RP" },
    {
      id: 11,
      path: "/gobig/paymentpolicies",
      title: "Payment Policy",
      ab: "PP",
    },
    {
      id: 12,
      path: "/gobig/fulfillmentpolicies",
      title: "Fulfillment Policy",
      ab: "FP",
    },
    { id: 13, path: "/gobig/viewinventory", title: "View Inventory", ab: "VI" },
    {
      id: 14,
      path: "/gobig/feedbackreminder",
      title: "Feedback Reminder",
      ab: "FR",
    },
    {
      id: 15,
      path: "/gobig/awaitingfeedbackitems",
      title: "Awaiting Feedback Items",
      ab: "AF",
    },
    {
      id: 16,
      path: "/gobig/feedbacksreceived",
      title: "Feedbacks Received",
      ab: "FR",
    },
    { id: 17, path: "/gobig/offers", title: "Offers", ab: "OF" },
  ];

  public bugReporting = [
    { id: 184, path: "/bug-reporting", title: "Bug Reporting", ab: "BG" },
  ];

  canCreate() {
    const permissionsMap = {
      statusInventoryClient: "inventory-client",
      statusBugReporting: "bugReporting",
    };

    for (const [variable, permissionKey] of Object.entries(permissionsMap)) {
      (this as any)[variable] = this.getParsedPermission(permissionKey);
    }

    this.buildAvailableOptions();
  }

  private buildAvailableOptions() {
    if (this.statusInventoryClient) {
      this.permissionStatus = true;
    }
    if (this.statusBugReporting) {
      this.bugstatus = true;
    }
  }

  private getParsedPermission(permissionKey: string): boolean {
    try {
      let st: any = this.guard.permissions(permissionKey);
      if (st === undefined || st === null) {
        console.error(`El permiso "${permissionKey}" es inválido:`, st);
        return false;
      }

      if (typeof st === "string") {
        if (st.trim() !== "" && st !== "undefined") {
          st = JSON.parse(st);
        } else {
          console.error(
            `La cadena de permiso "${permissionKey}" está vacía o no es JSON válido:`,
            st,
          );
          return false;
        }
      }

      return !!st;
    } catch (e) {
      console.error(`Error al obtener el permiso "${permissionKey}":`, e);
      return false;
    }
  }

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _userService: UserService,
    public guard: GuiGuard,
    private _poService: POService,
    public _globalNumberNotificationService: GlobalNumberNotificationsService,
    public _globalNumberNotificationsOffersService: GlobalNumberNotificationsOffersService,
    public routeGuard: BaseRouteGuard,
  ) {
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();

    if (this.identity.role != "MASTERADMIN") {
      this.getFavorites();
    }

    this.canCreate();

    if (this.identity.avatar) this.avatarImg = this.identity.avatar;

    if (this.identity.enableInventory === 1) {
      this.vendorStatus = true;
    } else if (this.identity.enableInventory === undefined) {
      this.vendorStatus = false;
    } else {
      this.vendorStatus = false;
    }

    ROUTES = [
      this.identity.role === "CUSTOMER" || this.identity.role === "customer"
        ? null
        : {
            path: "/dashboard",
            title: "Home",
            type: "link",
            icontype: "dashboard",
          },
      {
        path: "/agenda",
        title: "Calendar",
        type: "link",
        icontype: "date_range",
      },
      this.permissionStatus && this.vendorStatus
        ? {
            path: "/inventory-client",
            title: "Vendor Inventory",
            type: "link",
            icontype: "sort",
          }
        : null,
      {
        path: "/sales-deals-client",
        title: "Bid Marketplace",
        type: "link",
        icontype: "handshake",
      },
      {
        path: "clients",
        title: "Clients",
        type: "sub",
        icontype: "group",
        collapse: "clients",
        children: [
          {
            id: 18,
            path: "/tables/listcompanies",
            title: "Companies",
            ab: "Co",
          },
          { id: 19, path: "/vendors", title: "Vendors", ab: "V" },
          { id: 20, path: "/customers", title: "Customers", ab: "Cu" },
          { id: 21, path: "/mycontactforms", title: "My Leads", ab: "ML" },
          { id: 22, path: "/tables/listcontactform", title: "Leads", ab: "L" },
          { id: 23, path: "/tables/listlogs", title: "Access Logs", ab: "AL" },
          { id: 86, path: "/vendor-review", title: "Vendor Review", ab: "VR" },
        ],
      },
      this.identity.role === "VENDOR" || this.identity.role === "CUSTOMER"
        ? {
            path: "/tables/listfiles",
            title: "Reports",
            type: "link",
            icontype: "folder",
          }
        : {
            path: "files",
            title: "Files",
            type: "sub",
            icontype: "folder",
            collapse: "files",
            children: [
              {
                id: 24,
                path: "/centralizedfiles",
                title: "Centralized Files",
                ab: "CF",
              },
              {
                id: 25,
                path: "/tables/listfiles",
                title: "CV Files",
                ab: "CV",
              },
              { id: 26, path: "/reports", title: "Reports", ab: "R" },
              {
                id: 27,
                path: "/tables/listcompanyfiles",
                title: "Company Files",
                ab: "F",
              },
              {
                id: 28,
                path: "/questionnaire",
                title: "Questionnaire",
                ab: "Q",
              },
            ],
          },
      {
        path: "tools",
        title: "Tools",
        type: "sub",
        icontype: "build",
        collapse: "tools",
        children: [
          {
            id: 29,
            path: "/anonymusreporting",
            title: "Anonymous Reporting",
            ab: "AR",
          },
          {
            id: 30,
            path: "/backgroundprocess",
            title: "Background Processes",
            ab: "BP",
          },
          {
            id: 211,
            path: "/emails",
            title: "Emails",
            ab: "E",
          },
          { id: 31, path: "/hdchecker", title: "HDD Tools", ab: "HT" },
          {
            id: 32,
            path: "/insidelocation",
            title: "Inside a location",
            ab: "IL",
          },
          { id: 33, path: "/psa", title: "PSA", ab: "P" },
          { id: 34, path: "/reminders", title: "Reminders", ab: "R" },
          {
            id: 35,
            path: "/testing-record",
            title: "Testing Records",
            ab: "TR",
          },
          { id: 36, path: "/tickets", title: "Tickets", ab: "T" },
          { id: 37, path: "/holidays", title: "Time off Request", ab: "TO" },
          { id: 38, path: "/sign-sheet", title: "Visitors", ab: "V" },
          { id: 39, path: "/logsSystem", title: "Central Logs", ab: "CL" },
          { id: 40, path: "/weightbalance", title: "Weight Balance", ab: "WB" },
          { id: 41, path: "/forms-reports", title: "Forms", ab: "FR" },
          { id: 42, path: "/securaze", title: "Securaze", ab: "SR" },
          {
            id: 43,
            path: "/workflow-process",
            title: "Workflow Process",
            ab: "WP",
          },
          { id: 82, path: "/buybacks", title: "Employee Buy Back", ab: "WP" },
          { id: 83, path: "/leadlocation", title: "Lead Location", ab: "LL" },
          {
            id: 84,
            path: "/pickuplocation",
            title: "Pickup Location Stats",
            ab: "PLS",
          },
          {
            id: 85,
            path: "/vendorlocation",
            title: "Vendor Location",
            ab: "VL",
          },
        ],
      },
      {
        path: "e-commerce",
        title: "eCommerce v2",
        type: "sub",
        icontype: "store",
        collapse: "store",
        children: [
          {
            id: 88,
            path: "/e-commerce/listings",
            title: "Listings",
            ab: "L",
          },
          {
            id: 89,
            path: "/e-commerce/new-listing",
            title: "New Listing",
            ab: "NL",
          },
        ],
      },
      {
        path: "/bid-marketplace",
        title: "Auction Bid",  
        type: "link",
        icontype: "gavel",         
      },
      {
        path: "sell",
        title: "Sell",
        type: "sub",
        icontype: "payments",
        collapse: "sell",
        children: [
          { id: 44, path: "/salesproposal", title: "Sales Proposal", ab: "SP" },
          { id: 45, path: "/sales-orders", title: "Sales Orders", ab: "SO" },
          { id: 87, path: "/sales-deals", title: "Sales Deals", ab: "SD" },
          { id: 218, path: "/auctions", title: "Auctions", ab: "A" },
          { id: 46, path: "/invoices", title: "Invoices", ab: "I" },
        ],
      },
      {
        path: "buy",
        title: "Buy",
        type: "sub",
        icontype: "work",
        collapse: "buy",
        children: [
          {
            id: 47,
            path: "/purchaseproposal",
            title: "Purchase Proposal",
            ab: "PP",
          },
          {
            id: 48,
            path: "/purchase-order",
            title: "Purchase Orders",
            ab: "PO",
          },
          {
            id: 49,
            path: "/processing-instructions",
            title: "Processing Instructions",
            ab: "PI",
          },
          { id: 50, path: "/tables/listpagos", title: "Payments", ab: "PY" },
        ],
      },
      {
        path: "inventory",
        title: "Inventory",
        type: "sub",
        icontype: "sort",
        collapse: "inventory",
        children: [
          {
            id: 51,
            path: "/batch-container-inventory",
            title: "Batch Container Inventory",
            ab: "BCI",
          },
          {
            id: 52,
            path: "/container-inventory",
            title: "Container Inventory",
            ab: "CI",
          },
          {
            id: 53,
            path: "/inventoryhistory",
            title: "Inventory History",
            ab: "IH",
          },
          { id: 54, path: "/inventory", title: "Product Inventory", ab: "I" },
          { id: 55, path: "/manufacturer", title: "Manufacturer", ab: "M" },
          { id: 56, path: "/priceHistory", title: "Price History", ab: "PH" },
          // { path: '/product-inventory', title: 'Product Inventory', ab: 'PI' },
          {
            id: 57,
            path: "/scrap-inventory",
            title: "Scrap Inventory",
            ab: "SI",
          },
          { id: 58, path: "/write-downs", title: "Write Downs", ab: "WD" },
        ],
      },
      {
        path: "live-reporting",
        title: "Live Reporting",
        type: "sub",
        icontype: "analytics",
        collapse: "analytics",
        children: [
          {
            id: 78,
            path: "/live-reporting/inventory-reports-v2",
            title: "Inventory Reports",
            ab: "IR",
          },
          {
            id: 81,
            path: "/live-reporting/comparison-inventory-reports-v2",
            title: "Comparison Inventory Reports",
            ab: "CIR",
          },
          {
            id: 76,
            path: "/live-reporting/price-history-v2",
            title: "Price History",
            ab: "PH",
          },
          {
            id: 79,
            path: "/live-reporting/extra-missing-report-v2",
            title: "Extra Missing Report",
            ab: "EMR",
          },
          {
            id: 80,
            path: "/live-reporting/expense-reports-v3",
            title: "Expense Reports",
            ab: "ER",
          },
          {
            id: 63,
            path: "/inventoryReportsDownloadManager",
            title: "Download Manager",
            ab: "DM",
          },
        ],
      },
      {
        path: "shipments",
        title: "Order Processing",
        type: "sub",
        icontype: "local_shipping",
        collapse: "Shipments",
        children: [
          { id: 64, path: "/carriers", title: "Carriers", ab: "CA" },

          { id: 65, path: "/shipments", title: "Shipments List", ab: "SP" },
          {
            id: 205,
            path: "/shipment-scheduler",
            title: "Shipment Scheduler",
            ab: "SS",
          },
          { id: 66, path: "/returns", title: "Returns", ab: "SP" },
        ],
      },
      {
        path: "accounting",
        title: "Accounting",
        type: "sub",
        icontype: "account_balance",
        collapse: "accounting",
        children: [
          {
            id: 67,
            path: "/quickbooksconnect",
            title: "QuickBooks Connect",
            ab: "QB",
          },
          {
            id: 68,
            path: "/sync-quickbooks",
            title: "Sync with QuickBooks",
            ab: "SQ",
          },
          {
            id: 213,
            path: "/v2-quickbooks",
            title: "QuickBooks V2",
            ab: "Q2",
          },
        ],
      },
      {
        path: "settings",
        title: "Settings",
        type: "sub",
        icontype: "settings",
        collapse: "settings",
        children: [
          {
            id: 69,
            path: "/tables/listpersonal",
            title: "Representatives",
            ab: "R",
          },
          { id: 70, path: "/trucks", title: "Trucks", ab: "T" },
          { id: 71, path: "/permissions", title: "Permissions", ab: "P" },
        ],
      },
      {
        path: "/statistics",
        title: "Statistics",
        type: "link",
        icontype: "assessment",
      },
      {
        path: "setup",
        title: "Setup",
        type: "link",
        icontype: "build",
      },
      {
        path: "profile",
        title: "Profile",
        type: "sub",
        icontype: "person",
        collapse: "profile",
        children: [
          {
            id: 72,
            path: "/files-permissions-groups",
            title: "File Permissions Groups",
            ab: "FG",
          },
          {
            id: 73,
            path: "/pages/editprofile/1",
            title: "My Profile",
            ab: "MP",
          },
          {
            id: 74,
            path: "/tagging-groups",
            title: "Tagging Groups",
            ab: "TG",
          },
          {
            id: 75,
            path: "/visibilitytables",
            title: "Visibility Tables",
            ab: "VT",
          },
        ],
      },
    ];

    ROUTES[ROUTES.length - 1].children.push({
      id: 75,
      path: `/pages/userchangepassword/${this.identity.sub}`,
      title: "Change Password",
      ab: "CP",
    });

    if (typeof this.identity.userperms === "undefined") {
      localStorage.clear();
      this._router.navigate(["/pages/lock"]);
    }

    if (
      this.identity.userperms !== null &&
      this.identity.userperms.includes("37")
    ) {
      this.gobig = true;
    } else {
      this.gobig = false;
    }

    this.logoCompany =
      this.identity.companyLogo === "nologo"
        ? "/assets/img/greentek_solutions_logo.svg"
        : "https://itaderp.com/backend/resources/" + this.identity.companyLogo;
    if (typeof this.logoCompany === "undefined") {
      this.logoCompany = "/assets/img/greentek_solutions_logo.svg";
    }
    this.url_redirect = this.identity.logoRedirect
      ? this.identity.logoRedirect
      : "/";
    //console.log("sidebar identity",this.identity);
  }

  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  }

  logout() {
    localStorage.clear();
    this._router.navigate(["/"]);
    ROUTES[ROUTES.length - 1].children.pop();
    this._globalNumberNotificationService.numberNotifications = 0;
  }

  active(path) {
    if (this.identity.role === "MASTERADMIN") {
      return true;
    }

    if (
      path.includes("profile") ||
      path.includes("editprofile") ||
      path.includes("userchangepassword")
    ) {
      return true;
    }

    return this.routeGuard.checkPermissions(path);
  }

  activeSection(title) {
    if (this.identity.role === "MASTERADMIN") {
      return true;
    }

    switch (title) {
      case "Home":
        return true;
      case "Profile":
        return true;
      case "Calendar":
        return this.guard.permissions("agenda");
      case "Inventory-client":
        return this.guard.permissions("/inventory-client");
      case "Statistics":
        return this.guard.permissions("statistics");
      case "Clients":
        return (
          this.guard.permissions("listcompanies") ||
          this.guard.permissions("vendors") ||
          this.guard.permissions("customers") ||
          this.guard.permissions("mycontactforms") ||
          this.guard.permissions("listcontactform") ||
          this.guard.permissions("listlogs") ||
          this.guard.permissions("vendor-review")
        );
      case "eCommerce":
        return this.guard.permissions("Ecommerce");
      case "Files":
        return (
          this.guard.permissions("listfiles") ||
          this.guard.permissions("centralizedfiles") ||
          this.guard.permissions("reports") ||
          this.guard.permissions("listcompanyfiles") ||
          this.guard.permissions("questionnaire")
        );
      case "Tools":
        return (
          this.guard.permissions("hdchecker") ||
          this.guard.permissions("backgroundprocess") ||
          this.guard.permissions("testing-record") ||
          this.guard.permissions("holidays") ||
          this.guard.permissions("sign-sheet") ||
          this.guard.permissions("tickets") ||
          this.guard.permissions("psa") ||
          this.guard.permissions("insidelocation") ||
          this.guard.permissions("logsSystem") ||
          this.guard.permissions("weightbalance") ||
          this.guard.permissions("forms-reports") ||
          this.guard.permissions("anonymusreporting") ||
          this.guard.permissions("reminders") ||
          this.guard.permissions("buybacks") ||
          this.guard.permissions("leadlocation") ||
          this.guard.permissions("pickuplocation") ||
          this.guard.permissions("vendorlocation")
        );
      case "Auction Bid":
        return this.guard.permissions("bid-marketplace");
      case "Settings":
        return (
          this.guard.permissions("listpersonal") ||
          this.guard.permissions("trucks") ||
          this.guard.permissions("permissions")
        );
      case "Buy":
        return (
          this.guard.permissions("purchase-order") ||
          this.guard.permissions("processing-instructions") ||
          this.guard.permissions("listpagos") ||
          this.guard.permissions("proposal")
        );
      case "Inventory":
        return (
          this.guard.permissions("/inventory") ||
          this.guard.permissions("/batch-container-inventory") ||
          this.guard.permissions("/inventoryhistory") ||
          this.guard.permissions("priceHistory") ||
          this.guard.permissions("manufacturer") ||
          this.guard.permissions("master-types") ||
          this.guard.permissions("scrap-inventory") ||
          this.guard.permissions("write-downs") ||
          this.guard.permissions("container-inventory") ||
          this.guard.permissions("product-inventory")
        );
      case "Live Reporting":
        return (
          // this.guard.permissions('/inventoryReportExpenses')
          this.guard.permissions("live-reporting/inventory-reports-v2") ||
          this.guard.permissions(
            "live-reporting/comparison-inventory-reports-v2",
          ) ||
          this.guard.permissions("live-reporting/price-history-v2") ||
          this.guard.permissions("live-reporting/extra-missing-report-v2") ||
          this.guard.permissions("live-reporting/expense-reports-v3") ||
          this.guard.permissions("inventoryReportsDownloadManager")
        );
      case "Accounting":
        return (
          this.guard.permissions("quickbooksconnect") ||
          this.guard.permissions("v2-quickbooks") ||
          this.guard.permissions("sync-quickbooks")
        );
      case "Setup":
        return (
          this.guard.permissions("locations") ||
          this.guard.permissions("sale-terms") ||
          this.guard.permissions("purchase-terms") ||
          this.guard.permissions("notifications-perms") ||
          this.guard.permissions("system-setup") ||
          this.guard.permissions("master-items") ||
          this.guard.permissions("productCategory") ||
          this.guard.permissions("prouct-conditions") ||
          this.guard.permissions("taxauthorities") ||
          this.guard.permissions("visitorlink") ||
          this.guard.permissions("erasuremethods") ||
          this.guard.permissions("configpto") ||
          this.guard.permissions("containerstype")
        );
      case "eCommerce v2":
        return (
          this.guard.permissions("e-commerce/listings") ||
          this.guard.permissions("e-commerce/new-listing")
        );
      case "Sell":
        return (
          this.guard.permissions("salesproposal") ||
          this.guard.permissions("sales-orders") ||
          this.guard.permissions("sales-deals") ||
          this.guard.permissions("invoices") ||
          this.guard.permissions("auctions")
        );
      case "Bid Marketplace":
        return this.guard.permissions("sales-deals-client");
      case "Order Processing":
        return (
          this.guard.permissions("returns") ||
          this.guard.permissions("shipments")
        );
      default:
        return true;
    }
  }

  ngOnInit() {
    if (this.identity.role === "MASTERADMIN") {
      this.menuItems = MASTERROUTES.filter((menuItem) => menuItem);

      this.menuItems.forEach((element) => {
        // console.log("element => " , element);
        // console.log("this.activeSection(element.title) => ", this.activeSection(element.title));
        element.visible = this.activeSection(element.title);
        if (element.children) {
          element.children.forEach((elementInterno) => {
            elementInterno.visible = this.active(elementInterno.path);
          });
        }
      });
    } else {
      this.menuItems = ROUTES.filter((menuItem) => menuItem);

      if (this.identity.role === "VENDOR") {
        if (this.identity.companyId !== 1001 && this.identity.perm_lp !== 1) {
          this.menuItems = this.menuItems.filter(function (item) {
            return item.path !== "live-reporting";
          });
        }

        this.menuItems = this.menuItems.map((item) => {
          if (item.path === "/dashboard") {
            return {
              path: "/homeclient",
              title: "Home",
              type: "link",
              icontype: "dashboard",
              visible: true,
            };
          }
          return item;
        });
      }

      this.menuItems.forEach((element) => {
        // console.log("element => " , element);
        // console.log("this.activeSection(element.title) => ", this.activeSection(element.title));
        element.visible = this.activeSection(element.title);
        if (element.children) {
          element.children.forEach((elementInterno) => {
            elementInterno.visible = this.active(elementInterno.path);
          });
        }
      });

      if (this.identity.role === "VENDOR") {
        const buybacksOption = this.menuItems.some(
          (item) =>
            item.path === "tools" &&
            item.children?.some((child) => child.path === "/buybacks"),
        );
        // console.log('this.menuItems=>', this.menuItems);
        if (buybacksOption) {
          this.menuItems = this.menuItems.filter(
            (item) => item.path !== "tools",
          );
        }
        // console.log('this.menuItems=>', this.menuItems);
        const permission = JSON.parse(this.identity.userperms);
        // console.log('permission=>', permission);

        const isVisible = permission.includes(162);
        // console.log('isVisible=>', isVisible);

        this.menuItems.push({
          path: "/buybacks",
          title: "Employee Buy Back",
          type: "link",
          icontype: "shopping_cart",
          visible: isVisible,
        });
        // console.log('this.menuItems=>', this.menuItems);
      }
    }

    console.log("ngOnInit this.menuItems => ", this.menuItems);

    this._globalNumberNotificationsOffersService.numberNotificationsOffers$.subscribe(
      (value) => {
        this.numberNotificationsOffers = value;
      },
    );

    this.socketsUp();

    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      const elemSidebar = <HTMLElement>(
        document.querySelector(".sidebar .sidebar-wrapper")
      );
      this.ps = new PerfectScrollbar(elemSidebar);
    }
  }

  socketsUp() {
    let newtiming = new Date().getTime();
    let me = this;

    this.myWebSocket.next({
      registro_offers: this.token,
      time: newtiming,
    });

    this.myWebSocket.asObservable().subscribe(
      (msg) => {
        let msgCoded = JSON.stringify(msg);
        //console.log('message received sidebar: ' + msgCoded);
        if (msg.type === "offers") {
          //this.numberNotifications = msg.numberNotifications;
          let valornuevo = msg.offers;
          //this.notificationsOffers = valornuevo;
          //this._globalNumberNotificationsOffersService.numberNotificationsOffers = valornuevo;
          this._globalNumberNotificationsOffersService.setNumberNotificationsOffers(
            valornuevo,
          );
        }
      },
      // Called whenever there is a message from the server
      //las siguientes funciones son para reconectar la conexion al servidor websockets si es que perdemos la conexion
      (err) => {
        //console.log("error conexion websocket => ", err);
        if (err.type == "close") {
          //console.log("se perdio conexion con websockets server");
          setTimeout(function () {
            me.socketsUp();
          }, 60000);
        } else if (err.type == "error") {
          //console.log("se perdio conexion con websockets server");
          setTimeout(function () {
            me.socketsUp();
          }, 60000);
        }
      },
      // Called if WebSocket API signals some kind of error
      () => console.log("complete"),
      // Called when connection is closed (for whatever reason)
    );
  }

  updatePS(): void {
    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      this.ps.update();
    }
  }
  isMac(): boolean {
    let bool = false;
    if (
      navigator.platform.toUpperCase().indexOf("MAC") >= 0 ||
      navigator.platform.toUpperCase().indexOf("IPAD") >= 0
    ) {
      bool = true;
    }
    return bool;
  }
  expandOrCollapseMenu(id) {
    let parent = document.getElementById(id + "-p");
    let child = document.getElementById(id);
    parent.ariaExpanded = parent.ariaExpanded === "true" ? "false" : "true";
    child.style.height =
      child.style.height === "0px" || child.style.height === "" ? "100%" : "0";
  }

  addToFavorites(id) {
    this._userService.addToFavorites(this.token, id).subscribe(
      (response) => {
        if (response.status == "success") {
          this.getFavorites();
        } else {
        }
      },
      (error) => {
        console.log(<any>error);
      },
    );
  }

  removeFromFavorites(id) {
    this._userService.removeFromFavorites(this.token, id).subscribe(
      (response) => {
        if (response.status == "success") {
          this.getFavorites();
        } else {
        }
      },
      (error) => {
        console.log(<any>error);
      },
    );
  }

  getFavorites() {
    this._userService.getFavorites(this.token).subscribe(
      (response) => {
        if (response.status == "success") {
          let idToFind;
          let childrenFoundFlag = false;

          this.favoriteItems = [];

          if (response.data !== null) {
            for (idToFind of response.data) {
              childrenFoundFlag = false;

              // Busca el elemento con el id proporcionado
              ROUTES.forEach((item) => {
                if (item !== null) {
                  if (item.children) {
                    // Filtra los children que tienen el id proporcionado
                    const childrenWithId = item.children.filter(
                      (child) => child.id === idToFind,
                    );
                    // Agrega los children encontrados al array
                    if (childrenWithId.length > 0) {
                      childrenFoundFlag = true; // Se encontraron children
                      this.favoriteItems.push(...childrenWithId);
                    }
                  }
                }
              });

              if (!childrenFoundFlag) {
                const itemFound = this.unedaItems.find(
                  (item) => item.id === idToFind,
                );

                if (itemFound) {
                  this.favoriteItems.push(itemFound);
                } else {
                  const itemFound = this.ecommerceItems.find(
                    (item) => item.id === idToFind,
                  );

                  if (itemFound) {
                    this.favoriteItems.push(itemFound);
                  } else {
                    const itemFound = this.bugReporting.find(
                      (item) => item.id === idToFind,
                    );

                    if (itemFound) {
                      this.favoriteItems.push(itemFound);
                    }
                  }
                }
              }
            }

            this.favorites = response.data;
          } else this.favorites = [];
        }
      },
      (error) => {
        console.log(<any>error);
      },
    );
  }
}
